import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink, Smile, Sparkles } from 'lucide-react';
export function DemoSection() {
  return <section className="py-24 bg-[#0a0a1a] relative overflow-hidden" data-id="element-45">
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-purple-600/10 rounded-full blur-[120px] pointer-events-none" data-id="element-46" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-47">
        <div className="text-center mb-16" data-id="element-48">
          <h2 className="text-3xl md:text-5xl font-bold font-orbitron mb-4" data-id="element-49">
            Tus Clientes,{' '}
            <span className="text-gradient-cosmic" data-id="element-50">Felices y Confiados</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg" data-id="element-51">
            Creamos menús digitales que transmiten la misma confianza y
            profesionalismo que tus clientes sienten cuando visitan tu
            restaurante.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8 max-w-5xl mx-auto" data-id="element-52">
          {/* Dental Image */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="relative rounded-2xl overflow-hidden border border-white/10 group" data-id="element-53">
            <div className="aspect-[4/3] overflow-hidden" data-id="element-54">
              <img src="https://images.unsplash.com/photo-1504674900247-0877df9cc836?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Plato de comida gourmet" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-55" />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-[#050510] via-[#050510]/20 to-transparent" data-id="element-56" />
            <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-57">
              <div className="flex items-center gap-2 mb-2" data-id="element-58">
                <div className="w-8 h-8 rounded-full bg-cyan-500/20 flex items-center justify-center" data-id="element-59">
                  <Smile className="w-4 h-4 text-cyan-400" data-id="element-60" />
                </div>
                <span className="text-xs font-bold text-cyan-400 uppercase tracking-wider" data-id="element-61">
                  Gastronomía
                </span>
              </div>
              <h3 className="text-xl font-bold text-white font-orbitron" data-id="element-62">
                Tu menú, presentado como merece
              </h3>
              <p className="text-sm text-gray-400 mt-1" data-id="element-63">
                Mostrá tus platos con un menú digital que refleje la calidad de
                tu cocina.
              </p>
            </div>
          </motion.div>

          {/* Aesthetic Treatment Image */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.15
        }} className="relative rounded-2xl overflow-hidden border border-white/10 group" data-id="element-64">
            <div className="aspect-[4/3] overflow-hidden" data-id="element-65">
              <img src="https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Ambiente de restaurante" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-66" />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-[#050510] via-[#050510]/20 to-transparent" data-id="element-67" />
            <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-68">
              <div className="flex items-center gap-2 mb-2" data-id="element-69">
                <div className="w-8 h-8 rounded-full bg-pink-500/20 flex items-center justify-center" data-id="element-70">
                  <Sparkles className="w-4 h-4 text-pink-400" data-id="element-71" />
                </div>
                <span className="text-xs font-bold text-pink-400 uppercase tracking-wider" data-id="element-72">
                  Experiencia
                </span>
              </div>
              <h3 className="text-xl font-bold text-white font-orbitron" data-id="element-73">
                Un ambiente que se siente desde la pantalla
              </h3>
              <p className="text-sm text-gray-400 mt-1" data-id="element-74">
                Mostrá tu espacio para que tus clientes vean la experiencia que
                van a vivir.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Stats Row */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="flex flex-wrap justify-center gap-8 mt-12 max-w-3xl mx-auto" data-id="element-75">
          {[{
          value: '+40%',
          label: 'Más reservaciones'
        }, {
          value: '5 días',
          label: 'Tiempo de entrega'
        }, {
          value: '24/7',
          label: 'Tu menú digital trabaja por vos'
        }].map((stat, i) => <div key={i} className="text-center" data-id="element-76">
              <div className="text-2xl md:text-3xl font-bold text-gradient-cosmic font-orbitron" data-id="element-77">
                {stat.value}
              </div>
              <div className="text-xs text-gray-500 mt-1" data-id="element-78">{stat.label}</div>
            </div>)}
        </motion.div>

        <div className="mt-12 text-center" data-id="element-79">
          <a href="#precios" className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white/10 hover:bg-white/20 border border-white/20 text-white font-bold transition-all duration-300" data-id="element-80">
            Quiero un menú digital así para mi restaurante{' '}
            <ExternalLink className="w-4 h-4" data-id="element-81" />
          </a>
        </div>
      </div>
    </section>;
}